// extracted by mini-css-extract-plugin
export default {"status":"styles_status__mvyTJ","dot":"styles_dot__OjTPF","active":"styles_active__ock8W"};